/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcrResentNotificationResponseDto
 */
export interface EcrResentNotificationResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof EcrResentNotificationResponseDto
     */
    workflowInstanceId?: string;
    /**
     * User Id
     * @type {string}
     * @memberof EcrResentNotificationResponseDto
     */
    userId?: string;
}

/**
 * Check if a given object implements the EcrResentNotificationResponseDto interface.
 */
export function instanceOfEcrResentNotificationResponseDto(value: object): boolean {
    return true;
}

export function EcrResentNotificationResponseDtoFromJSON(json: any): EcrResentNotificationResponseDto {
    return EcrResentNotificationResponseDtoFromJSONTyped(json, false);
}

export function EcrResentNotificationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcrResentNotificationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function EcrResentNotificationResponseDtoToJSON(value?: EcrResentNotificationResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'userId': value['userId'],
    };
}

